import React, { useState, useEffect, useMemo } from 'react';
import { db, paths } from '../../firebase/config';
import { collection, query, where, onSnapshot, addDoc, deleteDoc, updateDoc, doc, getDocs, getDoc, setDoc } from 'firebase/firestore';
import { useAuth } from '../../context/AuthContext';

// --- ESTILOS RESPONSIVOS E ANIMAÇÕES ---
const styleTag = `
  /* --- ESTILOS GERAIS --- */
  .filter-toggle-btn { background: white; border: 1px solid #e2e8f0; padding: 8px; border-radius: 8px; cursor: pointer; display: flex; align-items: center; justify-content: center; color: #4a5568; box-shadow: 0 2px 4px rgba(0,0,0,0.05); transition: all 0.2s; }
  .filter-toggle-btn:hover { background: #f8fafc; }
  .gear-animated { transition: transform 0.4s ease-in-out; }
  .gear-animated.open { transform: rotate(-180deg); }
  .gear-animated.closed { transform: rotate(0deg); }
  
  .btn-add-animated { background-color: #38a169; color: white; border: none; border-radius: 30px; padding: 10px; cursor: pointer; display: flex; align-items: center; gap: 0; box-shadow: 0 4px 6px rgba(56, 161, 105, 0.4); transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275); height: 42px; min-width: 42px; justify-content: center; overflow: hidden; }
  .btn-add-animated span { max-width: 0; opacity: 0; white-space: nowrap; transition: all 0.3s ease; font-weight: 700; font-size: 13px; }
  .btn-add-animated:hover { padding: 10px 20px; gap: 8px; }
  .btn-add-animated:hover span { max-width: 150px; opacity: 1; }

  /* Controles Responsivos */
  .desktop-controls-wrapper { display: none; }
  .mobile-btn-wrapper { display: block; }
  .mobile-filters-panel { display: block; }
  @media (min-width: 769px) { .desktop-controls-wrapper { display: flex; gap: 16px; align-items: flex-end; } .mobile-btn-wrapper { display: none !important; } .mobile-filters-panel { display: none !important; } .btn-add-animated { padding: 10px 20px; gap: 8px; } .btn-add-animated span { max-width: 150px; opacity: 1; } }

  .filters-panel { background-color: white; padding: 16px; border-radius: 12px; box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1); margin-bottom: 16px; border: 1px solid #e2e8f0; animation: fadeInDown 0.3s ease-out; transform-origin: top center; }
  @keyframes fadeInDown { from { opacity: 0; transform: translateY(-10px) scaleY(0.95); } to { opacity: 1; transform: translateY(0) scaleY(1); } }
  .leadership-container { display: flex; align-items: flex-end; gap: 12px; }
  .leadership-item { flex: 1; min-width: 0; }
  .modal-overlay { position: fixed; inset: 0; background-color: rgba(15, 23, 42, 0.5); backdrop-filter: blur(4px); display: flex; justify-content: center; align-items: center; z-index: 1000; padding: 16px; animation: fadeIn 0.2s ease-out; }
  .modal-content { background-color: white; padding: 20px; border-radius: 12px; width: 100%; max-width: 520px; max-height: 95vh; overflow-y: auto; box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1); animation: slideUp 0.3s ease-out; }
  .modal-title { margin-top: 0; font-size: 18px; color: #1e293b; margin-bottom: 16px; font-weight: 800; }
  
  .form-group { margin-bottom: 12px; }
  .form-row { display: flex; gap: 12px; margin-bottom: 12px; flex-wrap: wrap; }
  .form-row > div { flex: 1 1 45%; }
  .form-section { padding: 12px; border-radius: 10px; margin-bottom: 16px; border: 1px solid #e2e8f0; background-color: #ffffff; }
  .form-section-light { padding: 10px 12px; border: 1px solid #e2e8f0; border-radius: 10px; background-color: #f8fafc; margin-bottom: 12px; }
  .modal-actions { display: flex; justify-content: flex-end; gap: 10px; margin-top: 16px; }
  .modern-label { display: block; font-size: 10px; font-weight: 700; color: #64748b; margin-bottom: 4px; text-transform: uppercase; letter-spacing: 0.5px; }
  .modern-input { width: 100%; padding: 8px 12px; border-radius: 8px; border: 1.5px solid #e2e8f0; font-size: 12px; color: #1e293b; background-color: #f8fafc; transition: all 0.2s ease; box-sizing: border-box; outline: none; font-family: inherit; height: 36px; }
  .modern-input:focus { border-color: #3b82f6; background-color: #ffffff; box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.15); }
  select.modern-input { appearance: none; background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24' stroke='%2364748b'%3E%3Cpath stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M19 9l-7 7-7-7'%3E%3C/path%3E%3C/svg%3E"); background-repeat: no-repeat; background-position: right 12px center; background-size: 14px; padding-right: 32px; cursor: pointer; }
  
  .multi-select-container { border: 1.5px solid #e2e8f0; border-radius: 8px; background: #f8fafc; max-height: 200px; overflow-y: auto; }
  .checkbox-item { display: flex; align-items: center; padding: 8px 12px; cursor: pointer; border-bottom: 1px solid #f1f5f9; transition: background 0.2s; }
  .checkbox-item:last-child { border-bottom: none; }
  .checkbox-item:hover { background-color: #edf2f7; }
  .checkbox-item.selected { background-color: #eff6ff; }
  .custom-checkbox { width: 16px; height: 16px; border: 2px solid #cbd5e1; border-radius: 4px; margin-right: 10px; display: flex; align-items: center; justify-content: center; transition: all 0.2s; flex-shrink: 0; }
  .checkbox-item.selected .custom-checkbox { background-color: #3b82f6; border-color: #3b82f6; }
  .checkbox-tick { color: white; font-size: 10px; font-weight: bold; }
  .cadete-name-select { font-size: 12px; color: #334155; font-weight: 600; }
  .toggle-mode-btn { background: none; border: none; font-size: 10px; color: #3b82f6; font-weight: 700; cursor: pointer; text-decoration: underline; padding: 0; }
  
  .modern-btn-primary { padding: 8px 20px; border-radius: 8px; border: none; background: #3b82f6; color: white; font-weight: 600; font-size: 13px; cursor: pointer; height: 36px; }
  .modern-btn-secondary { padding: 8px 20px; border-radius: 8px; border: none; background: #f1f5f9; color: #475569; font-weight: 600; font-size: 13px; cursor: pointer; height: 36px; }
  .modern-chip-btn { font-size: 11px; padding: 6px 12px; cursor: pointer; background-color: #f0fdf4; border: 1px solid #bbf7d0; border-radius: 20px; color: #166534; font-weight: 600; }

  @keyframes fadeIn { from { opacity: 0; } to { opacity: 1; } }
  @keyframes slideUp { from { opacity: 0; transform: translateY(15px); } to { opacity: 1; transform: translateY(0); } }

  /* --- TABELA RESPONSIVA --- */
  @media (max-width: 768px) {
    .main-container { padding: 12px 8px !important; }
    .mobile-stack { flex-direction: row !important; align-items: flex-start !important; justify-content: space-between !important; }
    .kpi-container { display: grid !important; grid-template-columns: repeat(3, 1fr) !important; gap: 8px !important; margin-bottom: 12px !important; }
    .kpi-card { padding: 16px 4px !important; min-height: 90px !important; }
    .responsive-table { width: 100% !important; display: block !important; }
    .responsive-table thead { display: none; }
    .responsive-table tbody { display: block; width: 100%; }
    .responsive-table tr { display: block; width: 100%; border: 1px solid #e2e8f0; border-radius: 8px; margin-bottom: 8px; background: #fff; overflow: hidden; box-sizing: border-box; }
    .cadete-header { display: flex; justify-content: space-between; align-items: center; padding: 10px 12px; cursor: pointer; background: #fff; width: 100%; box-sizing: border-box; gap: 8px; }
    .cadete-header-info { display: flex; align-items: center; gap: 8px; flex: 1; min-width: 0; }
    .cadete-name-mobile { font-weight: 700; color: #2d3748; font-size: 11px; text-transform: uppercase; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; max-width: 130px; }
    .cadete-tag-mobile { padding: 3px 6px; border-radius: 6px; font-size: 9px; font-weight: 800; white-space: nowrap; }
    .cadete-content { display: none; padding: 8px 12px 12px 12px; border-top: 1px solid #f7fafc; background: #fcfcfc; width: 100%; box-sizing: border-box; }
    .expanded .cadete-content { display: block; }
    .expanded .arrow-icon { transform: rotate(180deg); }
    .responsive-table td { display: flex; flex-direction: column; align-items: flex-start; padding: 8px 0 !important; border-bottom: 1px solid #f1f5f9 !important; font-size: 12px; width: 100%; }
    .responsive-table td:last-child { border-bottom: none !important; }
    .responsive-table td::before { content: attr(data-label); font-weight: 700; color: #718096; text-transform: uppercase; font-size: 10px; margin-bottom: 2px; }
    .arrow-icon { transition: transform 0.3s ease; color: #3182ce; flex-shrink: 0; }
  }

  @media (min-width: 769px) {
    .mobile-only { display: none !important; }
    .responsive-table { display: table !important; width: 100%; table-layout: fixed; border-collapse: separate; border-spacing: 0; }
    .responsive-table thead { display: table-header-group !important; }
    .responsive-table tbody { display: table-row-group !important; }
    .responsive-table tr { display: table-row !important; }
    .cadete-content { display: contents !important; }
    .responsive-table td, .responsive-table th { display: table-cell !important; padding: 10px 12px !important; border-bottom: 1px solid #edf2f7 !important; vertical-align: top; text-align: left; word-wrap: break-word; }
  }
`;

// --- ÍCONES ---
const TrashIcon = () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="3 6 5 6 21 6"></polyline><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path></svg>;
const EditIcon = () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path></svg>;
const SaveIcon = () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1-2-2h11l5 5v11a2 2 0 0 1-2 2z"></path><polyline points="17 21 17 13 7 13 7 21"></polyline><polyline points="7 3 7 8 15 8"></polyline></svg>;
const CheckCircleIcon = () => <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#27ae60" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path><polyline points="22 4 12 14.01 9 11.01"></polyline></svg>;
const AlertIcon = (props) => <svg {...props} width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="12" cy="12" x2="12" y2="12"></line><line x1="12" cy="16" x2="12.01" y2="16"></line></svg>;
const UsersIcon = () => <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#3498db" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path><circle cx="9" cy="7" r="4"></circle><path d="M23 21v-2a4 4 0 0 0-3-3.87"></path><path d="M16 3.13a4 4 0 0 1 0 7.75"></path></svg>;
const ChevronLeft = () => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="15 18 9 12 15 6"></polyline></svg>;
const ChevronRight = () => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="9 18 15 12 9 6"></polyline></svg>;
const ArrowDown = () => <svg className="arrow-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="6 9 12 15 18 9"></polyline></svg>;
const SettingsIcon = ({ className }) => <svg className={className} width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="3"></circle><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"></path></svg>;
const PlusIcon = () => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><line x1="12" y1="5" x2="12" y2="19"></line><line x1="5" y1="12" x2="19" y2="12"></line></svg>;

const CardNumber = ({ title, value, color, icon, bgColor }) => (
    <div className="kpi-card" style={{ 
        backgroundColor: bgColor || 'white', padding: '12px 16px', borderRadius: '12px', 
        boxShadow: '0 4px 6px rgba(0,0,0,0.04)', border: '1px solid rgba(0,0,0,0.04)',
        borderTop: `4px solid ${color}`, textAlign: 'center', display: 'flex', 
        flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100%', transition: 'all 0.2s'
    }}>
        <div className="kpi-title" style={{ fontSize: '11px', color: '#64748b', fontWeight: '800', textTransform: 'uppercase', marginBottom: '6px', letterSpacing: '0.5px' }}>{title}</div>
        <div className="kpi-value" style={{ fontSize: '28px', fontWeight: '800', color: color, display: 'flex', alignItems: 'center', gap: '8px', lineHeight: '1' }}>
            <span className="kpi-icon" style={{ display: 'flex', alignItems: 'center' }}>{icon}</span> {value}
        </div>
    </div>
);

const MAPA_HORARIOS = {
    "1º E 2º TEMPOS": { start: "08:15", end: "09:45" },
    "3º E 4º TEMPOS": { start: "10:00", end: "11:30" },
    "5º E 6º TEMPOS": { start: "13:00", end: "14:30" },
    "7º E 8º TEMPOS": { start: "14:45", end: "16:15" },
    "9º E 10º TEMPOS": { start: "16:30", end: "18:00" },
    "PERIODO MATUTINO": { start: "07:00", end: "12:00" },
    "PERIODO VESPERTINO": { start: "12:01", end: "18:00" },
    "PERIODO INTEGRAL": { start: "00:00", end: "23:59" }
};
const OPCOES_FORA_DA_AULA = Object.keys(MAPA_HORARIOS);

const formatDatePTBR = (dateString) => {
    if (!dateString) return '-';
    const [year, month, day] = dateString.split('-');
    return `${day}/${month}/${year}`;
};

const formatLaunchDate = (val) => {
    if (!val) return '';
    let date;
    if (val.seconds) date = new Date(val.seconds * 1000);
    else date = new Date(val);
    
    const day = String(date.getDate()).padStart(2, '0');
    const months = ['JAN', 'FEV', 'MAR', 'ABR', 'MAI', 'JUN', 'JUL', 'AGO', 'SET', 'OUT', 'NOV', 'DEZ'];
    const month = months[date.getMonth()];
    const year = String(date.getFullYear()).slice(-2);
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    return `${day}${month}${year} às ${hours}:${minutes}`;
};

const getTodayDate = () => new Date().toISOString().split('T')[0];

const getLastSunday18h = () => {
    const now = new Date();
    const dayOfWeek = now.getDay(); 
    const hours = now.getHours();
    const lastSunday = new Date(now);
    if (dayOfWeek === 0 && hours >= 18) {
        lastSunday.setHours(18, 0, 0, 0);
    } else {
        const daysToSubtract = dayOfWeek === 0 ? 7 : dayOfWeek;
        lastSunday.setDate(now.getDate() - daysToSubtract);
        lastSunday.setHours(18, 0, 0, 0);
    }
    return lastSunday.getTime();
};

const ResultadoOnlinePage = () => {
  const { userProfile } = useAuth();
  const userPelotao = userProfile?.pelotao_nome || userProfile?.pelotao || '';
  
  const [dataReferencia, setDataReferencia] = useState(getTodayDate());
  const [cadetesPelotao, setCadetesPelotao] = useState([]);
  const [todosRegistrosPelotao, setTodosRegistrosPelotao] = useState([]);
  const [liderancaTurma, setLiderancaTurma] = useState({ chefe: '', subChefe: '' });
  const [nomeTurma, setNomeTurma] = useState('');
  const [loadingConfig, setLoadingConfig] = useState(true);
  
  const [showFilters, setShowFilters] = useState(false);
  const [listaDestinosSimples, setListaDestinosSimples] = useState([]);
  const [listaDestinosComplexos, setListaDestinosComplexos] = useState([]);
  const [listaGremios, setListaGremios] = useState([]);
  const [listaEquipes, setListaEquipes] = useState([]);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [expandedId, setExpandedId] = useState(null);

  const [isMultiSelect, setIsMultiSelect] = useState(false);
  const [showPendingOnly, setShowPendingOnly] = useState(false);
  const [originalRecord, setOriginalRecord] = useState(null);

  const getInitialFormState = () => ({
    cadeteId: '', 
    cadetesIds: [],
    destino: '', 
    qru_motivo: '', qth_endereco: '', situacao: '', informacoes_complementares: '',
    periodo_inicio: dataReferencia, periodo_fim: dataReferencia, dias_quantidade: 1,
    isForaDaAula: false, motivoForaDaAula: ''
  });

  const [form, setForm] = useState(getInitialFormState());

  const destinosComDataExtra = ['AUX CMT CIA', 'AUX CMT PEL'];

  useEffect(() => {
    const fetchConfig = async () => {
      setLoadingConfig(true);
      try {
        const destRef = doc(db, 'artifacts', 'app-estagios', 'public', 'data', 'config_geral', 'destinos_opcoes');
        const destSnap = await getDoc(destRef);
        if (destSnap.exists()) {
          const d = destSnap.data();
          setListaDestinosSimples(d.simples || []);
          setListaDestinosComplexos(d.complexos || []);
        }
        const gremiosRef = doc(db, 'artifacts', 'app-estagios', 'public', 'data', 'config_geral', 'gremios_opcoes');
        const gremiosSnap = await getDoc(gremiosRef);
        if (gremiosSnap.exists()) {
          setListaGremios(gremiosSnap.data().gremios || []);
          setListaEquipes(gremiosSnap.data().equipes || []);
        }
        if (userPelotao) {
            const pelRef = collection(db, 'artifacts', 'app-estagios', 'public', 'data', 'pelotoes');
            const q = query(pelRef, where('nome', '==', userPelotao));
            const snap = await getDocs(q);
            if (!snap.empty) {
                const pelData = snap.docs[0].data();
                setNomeTurma(pelData.turma || pelData.turma_nome || '');
            }
        }
      } catch (e) { console.error(e); }
      setLoadingConfig(false);
    };
    fetchConfig();
  }, [userPelotao]);

  useEffect(() => {
    if (!userPelotao) return;
    const unsubUsers = onSnapshot(query(collection(db, paths.users), where('pelotao_nome', '==', userPelotao)), (snap) => {
      const data = snap.docs.map(d => ({ id: d.id, ...d.data() }));
      setCadetesPelotao(data.filter(u => ['cadete', 'cadete_academico', 'escalante', 'aspirante'].includes(u.nivel)));
    });
    
    const unsubLider = onSnapshot(doc(db, paths.lideranca_pelotoes, userPelotao), (snap) => {
      if (snap.exists()) {
          const data = snap.data();
          const limiteExpiracao = getLastSunday18h();
          if (!data.timestamp || data.timestamp < limiteExpiracao) {
              setLiderancaTurma({ chefe: '', subChefe: '' });
          } else {
              setLiderancaTurma(data);
          }
      } else {
          setLiderancaTurma({ chefe: '', subChefe: '' });
      }
    });

    const unsubRegs = onSnapshot(query(collection(db, paths.resultado_online), where('pelotao', '==', userPelotao)), (snap) => {
      // --- CRUCIAL: Aqui normalizamos o ID. O objeto dentro do state TERÁ O ID DO DOCUMENTO. ---
      setTodosRegistrosPelotao(snap.docs.map(d => {
          const data = d.data();
          const { id, ...cleanData } = data; // Remove ID falso interno
          return { ...cleanData, id: d.id }; // Usa ID real do documento
      }));
    });
    return () => { unsubUsers(); unsubLider(); unsubRegs(); };
  }, [userPelotao]);

  const sortedCadetes = useMemo(() => {
    return [...cadetesPelotao].sort((a, b) => (a.nome || '').trim().localeCompare((b.nome || '').trim(), 'pt-BR', { sensitivity: 'base' }));
  }, [cadetesPelotao]);

  const registrations = useMemo(() => {
    const dataFiltro = dataReferencia;
    return todosRegistrosPelotao.filter(reg => 
        reg.periodo_inicio <= dataFiltro && 
        reg.periodo_fim >= dataFiltro
    );
  }, [todosRegistrosPelotao, dataReferencia]);

  // --- FILTRO VISUAL PADRÃO (Sem firulas de histórico) ---
  const visibleRegistrations = useMemo(() => {
    const grouped = {};
    registrations.forEach(reg => {
        const key = reg.cadeteId || reg.cadeteNome;
        if (!grouped[key]) grouped[key] = [];
        grouped[key].push(reg);
    });

    let finalList = [];
    Object.values(grouped).forEach(group => {
        group.sort((a, b) => {
            const timeA = a.timestamp?.seconds || 0;
            const timeB = b.timestamp?.seconds || 0;
            return timeB - timeA;
        });

        const restricaoRecord = group.find(r => r.destino === 'RESTRIÇÃO');
        if (restricaoRecord) {
            finalList.push(restricaoRecord);
            const newestOther = group.find(r => r.id !== restricaoRecord.id);
            if (newestOther) finalList.push(newestOther);
        } else {
            if (group.length > 0) finalList.push(group[0]);
        }
    });
    return finalList;
  }, [registrations]);

  const qtdAusentesUnicos = useMemo(() => {
      const idsUnicos = new Set();
      visibleRegistrations.forEach(reg => {
          if (reg.cadeteId) idsUnicos.add(reg.cadeteId);
          else if (reg.cadeteNome) idsUnicos.add(reg.cadeteNome);
      });
      return idsUnicos.size;
  }, [visibleRegistrations]);

  const cadetesDisponiveis = useMemo(() => {
    return sortedCadetes.filter(cadete => {
        if (editingId && form.cadeteId === cadete.id) return true;
        const registrosDoCadete = registrations.filter(reg => 
            reg.cadeteId === cadete.id || 
            reg.cadeteNome === cadete.nome_guerra || 
            reg.cadeteNome === cadete.nome
        );
        if (showPendingOnly) return registrosDoCadete.length === 0;
        return registrosDoCadete.length < 2;
    });
  }, [sortedCadetes, registrations, editingId, form.cadeteId, showPendingOnly]);

  const handlePrevDay = () => {
    const d = new Date(dataReferencia); d.setDate(d.getDate() - 1); setDataReferencia(d.toISOString().split('T')[0]);
  };
  const handleNextDay = () => {
    const d = new Date(dataReferencia); d.setDate(d.getDate() + 1); setDataReferencia(d.toISOString().split('T')[0]);
  };

  const handleOpenModal = () => {
    if (!liderancaTurma.chefe || !liderancaTurma.subChefe) {
        setShowFilters(true);
        return alert('Atenção: Defina a chefia do pelotão! (O sistema reseta a chefia automaticamente todo domingo às 18h00).');
    }
    setEditingId(null); 
    setOriginalRecord(null);
    setForm(getInitialFormState()); 
    setIsMultiSelect(false);
    setShowPendingOnly(false);
    setIsModalOpen(true);
  };

  const handleEdit = (reg) => {
    setEditingId(reg.id); // reg.id agora é o ID REAL DO DOCUMENTO
    setOriginalRecord(reg);
    // Removemos qualquer ID interno antes de setar o formulário
    const { id, ...dataToEdit } = reg;
    setForm({ ...dataToEdit, cadeteId: cadetesPelotao.find(c => c.nome === reg.cadeteNome || c.nome_guerra === reg.cadeteNome)?.id || '' });
    setIsMultiSelect(false);
    setIsModalOpen(true);
  };

  // --- EXCLUSÃO INTELIGENTE: Deleta ID real e suas sombras ---
  const handleSmartDelete = async (reg) => {
      if(!window.confirm("Confirmar exclusão?")) return;
      setLoading(true);
      try {
          const idsToDelete = new Set([reg.id]);

          // Busca fantasmas
          const ghosts = todosRegistrosPelotao.filter(r => 
              (r.cadeteId === reg.cadeteId || r.cadeteNome === reg.cadeteNome) && 
              r.periodo_inicio <= dataReferencia && 
              r.periodo_fim >= dataReferencia &&
              r.status !== 'historico' && 
              r.id !== reg.id 
          );

          if (reg.destino === 'RESTRIÇÃO') {
              ghosts.filter(r => r.destino === 'RESTRIÇÃO').forEach(g => idsToDelete.add(g.id));
          } else {
              ghosts.filter(r => r.destino !== 'RESTRIÇÃO').forEach(g => idsToDelete.add(g.id));
          }

          const deletePromises = Array.from(idsToDelete).map(id => deleteDoc(doc(db, paths.resultado_online, id)));
          await Promise.all(deletePromises);
      } catch (e) {
          console.error(e);
          alert("Erro ao excluir.");
      } finally {
          setLoading(false);
      }
  };

  const handleFormChange = (fld, val) => {
    setForm(prev => {
      const upd = { ...prev, [fld]: val };
      if (fld === 'destino') {
          if (val === 'GRÊMIOS' && !listaGremios.includes(upd.informacoes_complementares)) upd.informacoes_complementares = '';
          else if (val === 'EQUIPES' && !listaEquipes.includes(upd.informacoes_complementares)) upd.informacoes_complementares = '';
          if (!listaDestinosSimples.includes(val)) {
             upd.isForaDaAula = false;
             upd.motivoForaDaAula = '';
          }
      }
      if (fld === 'periodo_inicio' || fld === 'periodo_fim') {
        const diff = new Date(upd.periodo_fim) - new Date(upd.periodo_inicio);
        upd.dias_quantidade = Math.max(0, Math.ceil(diff / 86400000) + 1);
      }
      return upd;
    });
  };

  const toggleCadeteSelection = (id) => {
      setForm(prev => {
          const currentIds = prev.cadetesIds || [];
          if (currentIds.includes(id)) {
              return { ...prev, cadetesIds: currentIds.filter(cid => cid !== id) };
          } else {
              return { ...prev, cadetesIds: [...currentIds, id] };
          }
      });
  };

  const handleToggleForaDaAula = () => {
    setForm(prev => ({ ...prev, isForaDaAula: !prev.isForaDaAula, motivoForaDaAula: !prev.isForaDaAula ? prev.motivoForaDaAula : '' }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.destino) return alert("Preencha o Destino");
    
    if (listaDestinosSimples.includes(form.destino) && !['GRÊMIOS', 'EQUIPES'].includes(form.destino) && !form.informacoes_complementares) {
      return alert("Preencha as Informações Complementares.");
    }
    if (listaDestinosComplexos.includes(form.destino) && (!form.qru_motivo || !form.situacao || !form.qth_endereco)) {
        return alert("Para destinos detalhados, preencha Motivo, Situação e Endereço.");
    }

    setLoading(true);
    try {
      const executorNomeGuerra = userProfile?.nome_guerra ? `Cad PM ${userProfile.nome_guerra}` : 'Não identificado';

      // --- REMOVE QUALQUER ID INTERNO ANTES DE SALVAR ---
      const { id, ...finalPayload } = form;
      
      if (!listaDestinosSimples.includes(finalPayload.destino)) {
         finalPayload.isForaDaAula = false;
         finalPayload.motivoForaDaAula = '';
      }

      if (editingId) {
          const basePayload = { 
              ...finalPayload, 
              editadoPor: userProfile.id, 
              nome_guerra_executor: executorNomeGuerra, 
              timestamp: new Date()
          };
          // Garante que não estamos salvando o 'id' dentro do documento
          delete basePayload.id;
          delete basePayload.cadetesIds;

          await updateDoc(doc(db, paths.resultado_online, editingId), basePayload);

      } 
      else {
          let targetIds = [];
          if (isMultiSelect) {
             targetIds = form.cadetesIds;
             if (targetIds.length === 0) return alert("Selecione pelo menos um Cadete.");
          } else {
             if (!form.cadeteId) return alert("Selecione o Cadete.");
             targetIds = [form.cadeteId];
          }

          const promises = targetIds.map(async (targetId) => {
              const cadeteObj = cadetesPelotao.find(c => c.id === targetId);
              const cadeteNome = cadeteObj?.nome_guerra || cadeteObj?.nome || 'Desconhecido';
              
              const payload = { 
                  ...finalPayload, 
                  cadeteId: targetId, 
                  pelotao: userPelotao, 
                  cadeteNome, 
                  criadoPor: userProfile.id, 
                  nome_guerra_executor: executorNomeGuerra, 
                  timestamp: new Date(),
                  status: 'ativo'
              };
              // Limpeza final antes do envio
              delete payload.id;
              delete payload.cadetesIds; 
              
              return addDoc(collection(db, paths.resultado_online), payload);
          });

          await Promise.all(promises);
      }

      setIsModalOpen(false);
    } catch (err) { 
        console.error(err);
        alert("Erro ao salvar."); 
    } finally { 
        setLoading(false); 
    }
  };

  const handleSaveLideranca = async () => {
    if (!userPelotao) return alert("Sem Pelotão definido.");
    if (!liderancaTurma.chefe || !liderancaTurma.subChefe) return alert("Selecione o Chefe e o Sub-Chefe para salvar.");
    try { 
        await setDoc(doc(db, paths.lideranca_pelotoes, userPelotao), { ...liderancaTurma, timestamp: new Date().getTime() }); 
        alert('Liderança salva com sucesso!'); 
    } catch (e) { console.error(e); }
  };

  const setQuickDuration = (days) => {
      const start = new Date(form.periodo_inicio); const end = new Date(start);
      end.setDate(start.getDate() + days); handleFormChange('periodo_fim', end.toISOString().split('T')[0]);
  };

  const controlesDataLideranca = (
    <>
        <div style={{ flex: 1, minWidth: '220px' }}>
            <label className="modern-label" style={{ marginBottom: '6px' }}>Data de Referência</label>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px', backgroundColor: '#f8fafc', padding: '6px 12px', borderRadius: '8px', border: dataReferencia === getTodayDate() ? '1px solid #e2e8f0' : '1px solid #f6ad55', height: '40px', boxSizing: 'border-box' }}>
                <button onClick={handlePrevDay} style={{ border: 'none', background: '#e2e8f0', borderRadius: '50%', width: '28px', height: '28px', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}><ChevronLeft /></button>
                <input type="date" value={dataReferencia} onChange={(e) => setDataReferencia(e.target.value)} style={{ border: 'none', fontWeight: '700', outline: 'none', textAlign: 'center', cursor: 'pointer', fontSize: '13px', background: 'transparent', width: '100%', minWidth: '110px' }} />
                <button onClick={handleNextDay} style={{ border: 'none', background: '#e2e8f0', borderRadius: '50%', width: '28px', height: '28px', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}><ChevronRight /></button>
            </div>
        </div>
        <div className="leadership-container" style={{ flex: 2, margin: 0, padding: 0, border: 'none', boxShadow: 'none', backgroundColor: 'transparent' }}>
            <div className="leadership-item">
                <label className="leadership-label modern-label" style={{marginBottom: '6px'}}>Chefe</label>
                <select className="modern-input" value={liderancaTurma.chefe} onChange={(e) => setLiderancaTurma({...liderancaTurma, chefe: e.target.value})} style={{ height: '40px', fontSize: '11px', fontWeight: '600' }}>
                    <option value="">Selecione...</option>
                    {sortedCadetes.map(c => <option key={c.id} value={c.nome_guerra || c.nome}>{c.nome_guerra || c.nome}</option>)}
                </select>
            </div>
            <div className="leadership-item">
                <label className="leadership-label modern-label" style={{marginBottom: '6px'}}>Sub-Chefe</label>
                <select className="modern-input" value={liderancaTurma.subChefe} onChange={(e) => setLiderancaTurma({...liderancaTurma, subChefe: e.target.value})} style={{ height: '40px', fontSize: '11px', fontWeight: '600' }}>
                    <option value="">Selecione...</option>
                    {sortedCadetes.map(c => <option key={c.id} value={c.nome_guerra || c.nome}>{c.nome_guerra || c.nome}</option>)}
                </select>
            </div>
            <button onClick={handleSaveLideranca} className="modern-btn-primary" style={{ width: '40px', height: '40px', padding: '0', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }} title="Salvar Liderança">
                <SaveIcon />
            </button>
        </div>
    </>
  );

  return (
    <div className="main-container" style={{ padding: '16px', backgroundColor: '#ffffff', minHeight: '100vh', fontFamily: 'sans-serif' }}>
      <style>{styleTag}</style>
      
      <div className="mobile-stack" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end', marginBottom: '16px', flexWrap: 'wrap', gap: '16px' }}>
        <div className="mobile-header-text">
            <h1 style={{ margin: 0, color: '#1a202c', fontSize: '22px', fontWeight: '800' }}>Resultado Online</h1>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginTop: '4px' }}>
                <span style={{ fontSize: '13px', fontWeight: '600', color: '#2b6cb0', backgroundColor: '#ebf8ff', padding: '2px 8px', borderRadius: '4px' }}>{userPelotao || 'ND'}</span>
                <span style={{ fontSize: '12px', color: '#718096' }}>{loadingConfig ? '• Carregando...' : (nomeTurma ? `• ${nomeTurma}` : '• Sem Turma')}</span>
            </div>
        </div>
        <div className="desktop-controls-wrapper">{controlesDataLideranca}</div>
        <div className="mobile-btn-wrapper">
            <button onClick={() => setShowFilters(!showFilters)} className="filter-toggle-btn" style={{ borderColor: showFilters ? '#38a169' : '#e2e8f0', color: showFilters ? '#38a169' : '#4a5568', backgroundColor: showFilters ? '#f0fdf4' : 'white' }}>
              <SettingsIcon className={`gear-animated ${showFilters ? 'open' : 'closed'}`} />
            </button>
        </div>
      </div>

      {showFilters && (<div className="filters-panel mobile-filters-panel"><div style={{ display: 'flex', flexDirection: 'column', gap: '16px', alignItems: 'stretch' }}>{controlesDataLideranca}</div></div>)}

      <div className="kpi-container" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '16px', marginBottom: '16px' }}>
        <CardNumber title={`EFETIVO`} value={cadetesPelotao.length} color="#3182ce" icon={<UsersIcon />} bgColor="#eff6ff" />
        <CardNumber title="PRONTO" value={cadetesPelotao.length - qtdAusentesUnicos} color="#38a169" icon={<CheckCircleIcon />} bgColor="#f0fdf4" />
        <CardNumber title="NOVIDADES" value={qtdAusentesUnicos} color="#e53e3e" icon={<AlertIcon />} bgColor="#fef2f2" />
      </div>

      <div style={{ backgroundColor: 'white', borderRadius: '10px', padding: window.innerWidth < 768 ? '8px' : '16px', boxShadow: '0 2px 4px rgba(0,0,0,0.05)', border: '1px solid #e2e8f0', overflow: 'hidden' }}>
        <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '16px', alignItems: 'center', flexWrap: 'wrap', gap: '12px' }}>
            <button onClick={handleOpenModal} className="btn-add-animated" title="Inserir Resultado"><PlusIcon /><span>Inserir Resultado</span></button>
        </div>

        <table className="responsive-table">
            <thead className="desktop-only">
                <tr style={{ background: '#f8fafc', color: '#64748b', fontSize: '11px', textAlign: 'left', textTransform: 'uppercase' }}>
                    <th style={{ padding: '10px 12px', borderBottom: '1px solid #e2e8f0', width: '20%' }}>Cadete</th>
                    <th style={{ padding: '10px 12px', borderBottom: '1px solid #e2e8f0', width: '15%' }}>Destino</th>
                    <th style={{ padding: '10px 12px', borderBottom: '1px solid #e2e8f0', width: '40%' }}>Detalhes</th>
                    <th style={{ padding: '10px 12px', borderBottom: '1px solid #e2e8f0', width: '15%' }}>Período</th>
                    <th style={{ padding: '10px 12px', borderBottom: '1px solid #e2e8f0', width: '10%', textAlign:'center' }}>Ações</th>
                </tr>
            </thead>
            <tbody>
                {visibleRegistrations.length === 0 ? (
                  <tr><td colSpan="5" style={{ textAlign: 'center', padding: '24px', color: '#a0aec0', fontSize: '13px' }}>Todo o efetivo está em forma.</td></tr>
                ) : (
                  visibleRegistrations.map(reg => {
                    const isComplexo = listaDestinosComplexos.includes(reg.destino);
                    return (
                      <tr key={reg.id} className={expandedId === reg.id ? 'expanded' : ''}>
                          <div className="cadete-header mobile-only" onClick={() => setExpandedId(expandedId === reg.id ? null : reg.id)}>
                              <div className="cadete-header-info">
                                <span className="cadete-name-mobile">{`Cad ${reg.cadeteNome}`}</span>
                                <span className="cadete-tag-mobile" style={{ backgroundColor: isComplexo ? '#fef2f2' : '#eff6ff', color: isComplexo ? '#ef4444' : '#3b82f6' }}>{reg.destino}</span>
                              </div>
                              <div className="arrow-icon"><ArrowDown /></div>
                          </div>
                          
                          <div className="cadete-content">
                              <td data-label="Cadete" style={{ padding: '10px 12px', fontWeight: '600', borderBottom: '1px solid #f1f5f9', fontSize: '12px', color: '#1e293b' }} className="desktop-only">{`Cad ${reg.cadeteNome}`}</td>
                              <td data-label="Destino" style={{ padding: '10px 12px', borderBottom: '1px solid #f1f5f9' }} className="desktop-only">
                                <span style={{ padding: '4px 8px', borderRadius: '12px', fontSize: '10px', backgroundColor: isComplexo ? '#fef2f2' : '#eff6ff', color: isComplexo ? '#ef4444' : '#3b82f6', fontWeight: '800' }}>{reg.destino}</span>
                              </td>
                              <td data-label="Detalhes" style={{ padding: '10px 12px', fontSize: '12px', borderBottom: '1px solid #f1f5f9', color: '#475569' }}>
                                  <div>
                                      {isComplexo ? (<>{reg.qru_motivo && <div style={{marginBottom: '2px'}}><strong style={{color:'#1e293b'}}>Motivo:</strong> {reg.qru_motivo}</div>}{reg.situacao && <div style={{marginBottom: '2px'}}><strong style={{color:'#1e293b'}}>Situação:</strong> {reg.situacao}</div>}{reg.qth_endereco && <div><strong style={{color:'#1e293b'}}>Endereço:</strong> {reg.qth_endereco}</div>}</>) : (<div>{reg.informacoes_complementares || '-'}</div>)}
                                      {reg.isForaDaAula && <div style={{ color: '#ef4444', fontWeight: '700', fontSize: '10px', marginTop: '4px' }}>[FORA DE AULA]: {reg.motivoForaDaAula}</div>}
                                      <div style={{ fontSize: '9px', color: '#94a3b8', marginTop: '4px' }}>
                                        Lançado por: {reg.nome_guerra_executor} em: {formatLaunchDate(reg.timestamp)}
                                      </div>
                                  </div>
                              </td>
                              <td data-label="Período" style={{ padding: '10px 12px', fontSize: '12px', borderBottom: '1px solid #f1f5f9', color: '#475569' }}>{formatDatePTBR(reg.periodo_inicio)} - {formatDatePTBR(reg.periodo_fim)}</td>
                              <td data-label="Ações" style={{ padding: '10px 12px', borderBottom: '1px solid #f1f5f9', textAlign: 'center' }}>
                                  <div style={{ display: 'flex', gap: '6px', justifyContent:'center' }}>
                                      <button onClick={() => handleEdit(reg)} style={{ color: '#3b82f6', background: '#eff6ff', border: 'none', padding: '6px', borderRadius: '6px', cursor: 'pointer', transition: 'background 0.2s' }}><EditIcon /></button>
                                      {/* --- BOTÃO DE EXCLUSÃO INTELIGENTE --- */}
                                      <button onClick={() => handleSmartDelete(reg)} style={{ color: '#ef4444', background: '#fef2f2', border: 'none', padding: '6px', borderRadius: '6px', cursor: 'pointer', transition: 'background 0.2s' }}><TrashIcon /></button>
                                  </div>
                              </td>
                          </div>
                      </tr>
                    );
                  }))}
            </tbody>
        </table>
      </div>

      {isModalOpen && (
        <div className="modal-overlay">
            <div className="modal-content">
                <h2 className="modal-title">{editingId ? 'Editar Lançamento' : 'Novo Lançamento'}</h2>
                <form onSubmit={handleSubmit}>
                    
                    <div className="form-group">
                        <div style={{display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:'4px'}}>
                            <label className="modern-label" style={{marginBottom:0}}>
                                {editingId ? 'Cadete' : (isMultiSelect ? 'Selecione os Cadetes' : 'Cadete')}
                            </label>
                            
                            <div style={{display:'flex', gap:'10px'}}>
                                {!editingId && (
                                    <button type="button" onClick={() => setShowPendingOnly(!showPendingOnly)} className="toggle-mode-btn" style={{color: showPendingOnly ? '#e53e3e' : '#3b82f6'}}>
                                        {showPendingOnly ? 'Mostrar Todos' : 'Ocultar Lançados'}
                                    </button>
                                )}
                                {!editingId && (
                                    <button type="button" onClick={() => setIsMultiSelect(!isMultiSelect)} className="toggle-mode-btn">
                                        {isMultiSelect ? 'Selecionar Individual' : 'Selecionar Vários'}
                                    </button>
                                )}
                            </div>
                        </div>
                        
                        {(!isMultiSelect || editingId) ? (
                             <select className="modern-input" value={form.cadeteId} onChange={e => handleFormChange('cadeteId', e.target.value)} required disabled={!!editingId}>
                                <option value="">Selecione...</option>
                                {cadetesDisponiveis.map(c => <option key={c.id} value={c.id}>{c.nome_guerra || c.nome}</option>)}
                             </select>
                        ) : (
                            <div className="multi-select-container">
                                {cadetesDisponiveis.length === 0 ? (
                                    <div style={{padding:'12px', fontSize:'11px', color:'#94a3b8', textAlign:'center'}}>Nenhum cadete disponível.</div>
                                ) : (
                                    cadetesDisponiveis.map(c => {
                                        const isSelected = form.cadetesIds?.includes(c.id);
                                        return (
                                            <div key={c.id} className={`checkbox-item ${isSelected ? 'selected' : ''}`} onClick={() => toggleCadeteSelection(c.id)}>
                                                <div className="custom-checkbox">{isSelected && <span className="checkbox-tick">✓</span>}</div>
                                                <span className="cadete-name-select">{c.nome_guerra || c.nome}</span>
                                            </div>
                                        );
                                    })
                                )}
                            </div>
                        )}
                        {!editingId && isMultiSelect && <div style={{fontSize: '10px', color: '#64748b', marginTop: '4px', textAlign:'right'}}>{form.cadetesIds?.length || 0} selecionado(s)</div>}
                    </div>

                    <div className="form-group">
                        <label className="modern-label">Destino</label>
                        <select 
                            className="modern-input" 
                            value={form.destino} 
                            onChange={e => handleFormChange('destino', e.target.value)} 
                            required
                            disabled={!!editingId} // --- TRAVADO NA EDIÇÃO ---
                            style={editingId ? {backgroundColor: '#e2e8f0', cursor: 'not-allowed'} : {}}
                        >
                            <option value="">Selecione...</option>
                            <optgroup label="Simples">{listaDestinosSimples.map(d => <option key={d} value={d}>{d}</option>)}</optgroup>
                            <optgroup label="Detalhados">{listaDestinosComplexos.map(d => <option key={d} value={d}>{d}</option>)}</optgroup>
                        </select>
                    </div>

                    {listaDestinosSimples.includes(form.destino) && (
                        <div className="form-group">
                            <div className="form-section-light">
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                    <span style={{ fontSize: '12px', fontWeight: '700', color: '#334155' }}>Fora da Aula?</span>
                                    <button type="button" onClick={handleToggleForaDaAula} style={{ padding: '4px 12px', backgroundColor: form.isForaDaAula ? '#ef4444' : '#e2e8f0', color: form.isForaDaAula ? '#fff' : '#475569', border: 'none', borderRadius: '20px', cursor: 'pointer', fontSize: '10px', fontWeight: '700', transition: 'all 0.2s' }}>
                                        {form.isForaDaAula ? 'SIM' : 'NÃO'}
                                    </button>
                                </div>
                                {form.isForaDaAula && (
                                    <select value={form.motivoForaDaAula} onChange={e => handleFormChange('motivoForaDaAula', e.target.value)} className="modern-input" style={{ marginTop: '8px' }} required>
                                        <option value="">Selecione o Tempo...</option>
                                        {OPCOES_FORA_DA_AULA.map(o => <option key={o} value={o}>{o}</option>)}
                                    </select>
                                )}
                            </div>

                            {form.destino === 'GRÊMIOS' ? (
                                <>
                                    <label className="modern-label">Selecione o Grêmio</label>
                                    <select className="modern-input" value={form.informacoes_complementares} onChange={e => handleFormChange('informacoes_complementares', e.target.value)} required>
                                        <option value="">Selecione o grêmio...</option>
                                        {listaGremios.map(g => <option key={g} value={g}>{g}</option>)}
                                    </select>
                                </>
                            ) : form.destino === 'EQUIPES' ? (
                                <>
                                    <label className="modern-label">Selecione a Equipe</label>
                                    <select className="modern-input" value={form.informacoes_complementares} onChange={e => handleFormChange('informacoes_complementares', e.target.value)} required>
                                        <option value="">Selecione a equipe...</option>
                                        {listaEquipes.map(eq => <option key={eq} value={eq}>{eq}</option>)}
                                    </select>
                                </>
                            ) : (
                                <>
                                    <label className="modern-label">Informações Complementares</label>
                                    <input 
                                        className="modern-input" 
                                        value={form.informacoes_complementares} 
                                        onChange={e => handleFormChange('informacoes_complementares', e.target.value)} 
                                        required 
                                        placeholder="Ex: Al de Dia"
                                    />
                                </>
                            )}
                        </div>
                    )}
                    
                    {(listaDestinosComplexos.includes(form.destino) || destinosComDataExtra.includes(form.destino)) && (
                        <div className="form-section">
                            {listaDestinosComplexos.includes(form.destino) && (
                                <>
                                    <div className="form-group">
                                        <label className="modern-label">Motivo / QRU</label>
                                        <textarea className="modern-input" value={form.qru_motivo} onChange={e => handleFormChange('qru_motivo', e.target.value)} required placeholder="Descreva o motivo..." />
                                    </div>
                                    <div className="form-row">
                                        <div>
                                            <label className="modern-label">Situação</label>
                                            <select 
                                                className="modern-input" 
                                                value={form.situacao} 
                                                onChange={e => handleFormChange('situacao', e.target.value)} 
                                                required
                                            >
                                                <option value="">Selecione...</option>
                                                <option value="RESIDÊNCIA">RESIDÊNCIA</option>
                                                <option value="ALOJAMENTO">ALOJAMENTO</option>
                                                <option value="ROTINA NORMAL">ROTINA NORMAL</option>
                                                <option value="SERVIÇO FORA">SERVIÇO FORA</option>
                                                <option value="OUTROS FORA">OUTROS FORA</option>
                                            </select>
                                        </div>
                                        <div><label className="modern-label">Endereço / QTH</label><input className="modern-input" value={form.qth_endereco} onChange={e => handleFormChange('qth_endereco', e.target.value)} required placeholder="R. Alino Paiva, 68, Osasco/SP" /></div>
                                    </div>
                                </>
                            )}
                            
                            <div className="date-inputs-wrapper" style={{ display: 'flex', gap: '12px' }}>
                                <div className="date-input-field" style={{ flex: 1 }}>
                                    <label className="modern-label">Início</label>
                                    <input 
                                        type="date" 
                                        className="modern-input" 
                                        value={form.periodo_inicio} 
                                        onChange={e => handleFormChange('periodo_inicio', e.target.value)} 
                                        required 
                                        disabled={!!editingId} // --- TRAVADO NA EDIÇÃO ---
                                        style={editingId ? {backgroundColor: '#e2e8f0', cursor: 'not-allowed'} : {}}
                                    />
                                </div>
                                <div className="date-input-field" style={{ flex: 1 }}>
                                    <label className="modern-label">Fim</label>
                                    <input 
                                        type="date" 
                                        className="modern-input" 
                                        value={form.periodo_fim} 
                                        onChange={e => handleFormChange('periodo_fim', e.target.value)} 
                                        required 
                                        disabled={!!editingId} // --- TRAVADO NA EDIÇÃO ---
                                        style={editingId ? {backgroundColor: '#e2e8f0', cursor: 'not-allowed'} : {}}
                                    />
                                </div>
                            </div>
                            
                            {/* Oculta botões de duração rápida na edição */}
                            {!editingId && (
                                <div style={{ display: 'flex', gap: '8px', marginTop: '10px', flexWrap: 'wrap' }}>
                                    {[0,1,2,7].map(d => (
                                        <button key={d} type="button" className="modern-chip-btn" onClick={() => setQuickDuration(d)}>
                                            {d === 0 ? 'Hoje' : `+${d}d`}
                                        </button>
                                    ))}
                                </div>
                            )}
                        </div>
                    )}

                    <div className="modal-actions">
                        <button type="button" onClick={() => setIsModalOpen(false)} className="modern-btn-secondary">Cancelar</button>
                        <button type="submit" className="modern-btn-primary" disabled={loading}>{loading ? 'Salvando...' : 'Salvar'}</button>
                    </div>
                </form>
            </div>
        </div>
      )}
    </div>
  );
};

export default ResultadoOnlinePage;